export default __webpack_public_path__ + "static/media/Nicolette.6e8296eb.jpg";